import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { CommentsWithFileInputFormProps } from "models/propTypes/commentViewPropTypes";
//#endregion
//#region components
import CommentAndFileInputFormContainer from "./forms/commentAndFileInputFormContainer";
import { Grid } from "@mui/material";
import ManualConversation from "./manualConversation";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const CommentsViewWithInputForm: ForwardRefRenderFunction<FormHandles, CommentsWithFileInputFormProps> = (
  props,
  ref
) => {
  const {
    parentId,
    handleSubmit,
    commentType,
    initialValues,
    nonExpandable,
    showPostWithoutImage,
    showMarkAsResolved,
    commentOrFileRequired,
    onUploadedFilesChangeHandler,
    onFormUpdate,
    attachmentsHiddenCondition,
  } = props;

  return (
    <Grid container className={cssExports.commentsWithFileUploader} rowGap={1.25} marginTop={1.25}>
      {typeof parentId === "number" && <ManualConversation parentId={parentId} commentType={commentType} />}
      <Grid container item>
        <CommentAndFileInputFormContainer
          ref={ref}
          initialValues={initialValues}
          showPostWithoutImage={showPostWithoutImage}
          showMarkAsResolved={showMarkAsResolved}
          commentOrFileRequired={commentOrFileRequired}
          handleSubmit={handleSubmit}
          nonExpandable={nonExpandable}
          onUploadedFilesChangeHandler={onUploadedFilesChangeHandler}
          onFormUpdate={onFormUpdate}
          attachmentsHiddenCondition={attachmentsHiddenCondition}
        />
      </Grid>
    </Grid>
  );
};

export default forwardRef(CommentsViewWithInputForm);
